module.exports = __webpack_public_path__ + "static/living-soil-blog-f3ff29ff51b5e5b5476e16e1c8a71aeb.png";